import { Alert, Box, Chip, Divider, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { toJalaliFullDate } from "../../../middleware/middleware";

const RequestTimelineTab = ({ history = [], formatUpdateTypeLabel }) => {
  if (!history.length) {
    return (
      <Alert severity="info" sx={{ py: 1 }}>
        تاریخچه تغییر وضعیت برای این درخواست ثبت نشده یا در دسترس نیست.
      </Alert>
    );
  }

  return (
    <Stack spacing={1} divider={<Divider flexItem />}>
      {history.map((item) => (
        <Box key={item.id ?? `${item.createOn}-${item.description}`} sx={{ py: 0.25 }}>
          <Stack direction="row" spacing={0.75} flexWrap="wrap" alignItems="center">
            <Chip
              size="small"
              label={formatUpdateTypeLabel(item.updateType)}
              color="primary"
              variant="outlined"
              sx={{ height: 22 }}
            />
            <Typography variant="caption" color="text.secondary">
              {toJalaliFullDate(item.createOn)}
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ mt: 0.5, lineHeight: 1.4 }}>
            {item.description || "—"}
          </Typography>
          {item.fullName ? (
            <Typography variant="caption" color="text.secondary">
              {item.fullName}
            </Typography>
          ) : null}
        </Box>
      ))}
    </Stack>
  );
};

RequestTimelineTab.propTypes = {
  history: PropTypes.array,
  formatUpdateTypeLabel: PropTypes.func.isRequired,
};

export default RequestTimelineTab;
